import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";

import {login} from "../../../helpers/backend_helper";

// const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
      const { app_code } = user;
      console.log("Login request data:", { app_code });

      const { data } = yield call(login, app_code);
      console.log("Login API response:", data);

      if (data && typeof data === "object") {
        localStorage.setItem("authUser", JSON.stringify(data));
        yield put(loginSuccess(data));

        if (history && typeof history === "function") {
          history("/dashboard");
        } else {
          console.error("History function is missing or invalid");
        }
      } else {
        yield put(apiError("CONNECTION REFUSED"));
      }
  } catch (error) {
      console.log("Login error:", error);
      yield put(apiError(error.message || "Unknown error"));
  }
}


function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
